import React from 'react';
import { useTheme } from '@material-ui/core';
import FormML from './FormMLNew';
import StepFourStyled from './StepFourMLStyles';

export default (props) => {
  const theme = useTheme();
  return (
    <StepFourStyled theme={theme}>
      <FormML {...props} />
    </StepFourStyled>
  );
};
